export default {"src":"/_next/static/media/armchair.c46f8515.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};